import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import {
  useHistory,
  useRouteMatch,
  useLocation,
  Switch,
  Route,
} from 'react-router'
import ActionButtonComponent from '../../../components/common/actionButton/ActionButtonComponent'
import LoadingComponent from '../../../components/common/loading/LoadingComponent'
import { ActionListModal } from '../../../models/package/actionListModal'
import { getUserSubPackageActions } from '../../../store/user/selectors'
import PropertyDamageTypeServices from '../../../services/systemConfiguration/propertyDamageType/propertyDamageTypeServices'
import rejection_return_reason from '../../../assets/images/systemConfiguration/rejection-return-reason.svg'
import { propertyDamageTypeFilters } from '../../../utils/metaData'
import { filtersSetRequest } from '../../../store/filter/actions'
import { getFilters } from '../../../store/filter/selectors'
import { FilterModel } from '../../../models/utils/filterModel'
import { getPageCount } from '../../../utils/tableFunctions'
import { FilterOptionModel } from '../../../models/utils/filterOption'
import produce from 'immer'
import IterminalTableComponent from '../../../components/table/IterminalTableComponent'
import AddPropertyDamageType from './AddPropertyDamageType'
import ModifyPropertyDamageType from './ModifyPropertyDamageType'
import ViewPropertyDamageType from './ViewPropertyDamageType'
import PropertyDamageFilters from '../../../components/filters/PropertyDamageFilters'
import {
  defaultPageLimit,
  defaultOrderListLimit,
} from '../../../utils/constants'
const PropertyDamageType = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [propertyDataList, setPropertyDataList] = useState([])
  const pending = false
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const history = useHistory()
  const { path } = useRouteMatch()
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const filterOption = {
    descending: true,
    limit: defaultPageLimit,
    orderFields: defaultOrderListLimit,
  } as FilterModel
  const [filter, setFilter] = useState(filterOption)
  const [pageCount, setPageCount] = useState(0)
  const [dataCount, setDatacount] = useState(0)
  const filters = useSelector(getFilters)
  const dispatch = useDispatch()

  const actionList = useSelector(
    getUserSubPackageActions('system-configuration', 'property-damage-type')
  )

  const checkPermission = (permissionName: string) => {
    const filterdAction = actionList.filter((action: ActionListModal) => {
      if (action.action.name === permissionName) {
        return action
      }
    })[0]
    if (filterdAction != null) {
      return true
    } else {
      return false
    }
  }
  useEffect(() => {
    dispatch(filtersSetRequest({ filters: propertyDamageTypeFilters }))
    async function getIncidentTypesData() {
      await retriveDataCountAndData(filter)
      setLoading(false)
    }
    getIncidentTypesData()
  }, [location.pathname])
  async function retriveDataCountAndData(filterData: FilterModel) {
    const propertyCountData =
      await PropertyDamageTypeServices.apiFetchPropertyListCount(filterData)
    setDatacount(propertyCountData.data.count)
    setPageCount(getPageCount(propertyCountData.data.count, filterOption.limit))
    const propertyData = await PropertyDamageTypeServices.apiFetchPropertyList(
      filterData
    )
    setPropertyDataList(propertyData.data)
  }

  const retriveFilterData = async (selectedFilters: FilterOptionModel[]) => {
    console.log(selectedFilters)
    setLoading(true)
    const newFilter = produce(filter, (draft) => {
      draft.page = 1
      draft.filterData = selectedFilters
    })
    setFilter(newFilter)
    await retriveDataCountAndData(newFilter)
    setLoading(false)
  }

  const retriveIncidentData = async (pageDetails: any) => {
    setLoading(true)
    const newFilter = produce(filter, (draft) => {
      draft.page = pageDetails.pageIndex + 1
    })
    setFilter(newFilter)

    const propertyData = await PropertyDamageTypeServices.apiFetchPropertyList(
      newFilter
    )
    setPropertyDataList(propertyData.data)
    setLoading(false)
  }
  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
      },
      {
        Header: 'Property Description',
        accessor: 'propertyDescription',
      },
      {
        Header: 'Property Field List',
        id: 'propertyFieldList',
        accessor: (data: { propertyFieldList: any[] }) => {
          const output: any[] = []
          data.propertyFieldList.map((item) => {
            return output.push(item.propertyField)
          })
          return output.join(', ')
        },
      },
      {
        Header: 'Scheme',
        accessor: 'scheme',
      },
      {
        Header: 'Status',
        accessor: 'status',
      },
    ],
    []
  )
  const handleView = (id: number) => {
    history.push(`${path}/view/${id}`)
  }
  return (
    <>
      <Row className="title-layout">
        <Col className="d-flex justify-content-start">
          <img src={rejection_return_reason} alt="" />
          <span className="m-2">Property Damage Type</span>
        </Col>
      </Row>
      {pending ? (
        <div className="loading-layout">
          <LoadingComponent />
        </div>
      ) : (
        <Switch>
          <Route path={`${path}/`} exact>
            <Row className="incident-types-body-layout mt-4">
              <Col sm={12} className="mb-4">
                <Row>
                  <Col sm={6}>
                    {checkPermission('view') === true && !loading && (
                      <PropertyDamageFilters
                        filterData={filters}
                        onFilter={(e: FilterOptionModel[]) => {
                          dispatch(filtersSetRequest({ filters: e }))
                          retriveFilterData(
                            e.filter(
                              (filter: FilterOptionModel) =>
                                filter.selected === true
                            )
                          )
                        }}
                      />
                    )}
                  </Col>
                  <Col sm={6} className="d-flex justify-content-end">
                    {checkPermission('add') === true && (
                      <ActionButtonComponent name="Add" routeURL="add" />
                    )}
                  </Col>
                </Row>
              </Col>
              <Col sm={12}>
                <IterminalTableComponent
                  columns={columns}
                  data={propertyDataList}
                  fetchData={retriveIncidentData}
                  loading={loading}
                  pageCount={pageCount}
                  totalCount={dataCount}
                  onClickRow={(row: any) => {
                    console.log(row)
                    handleView(row.id)
                  }}
                />
              </Col>
            </Row>
          </Route>
          <Route path={`${path}/add`} component={AddPropertyDamageType} />
          <Route path={`${path}/view/:id`} component={ViewPropertyDamageType} />
          <Route
            path={`${path}/modify/:id`}
            component={ModifyPropertyDamageType}
          />
        </Switch>
      )}
    </>
  )
}

export default PropertyDamageType
